<script>
export default {
  name: 'Tooltip',
  props: {
    tipDesc: {
      type: String,
      required: true,
    },
    positionX: {
      type: [Number, String],
      required: true,
      default: () => 0,
    },
    positionY: {
      type: [Number, String],
      required: true,
      default: () => 0,
    },
  },
  computed: {
    position() {
      return { left: `${this.positionX}px`, top: `${this.positionY}px` };
    },
  },
};
</script>

<template>
  <div :style="position" class="tool-tip">{{ tipDesc }}</div>
</template>
